<template>
  <div>
    <DxDropDownButton
      :items="getItems"
      :keyExpr="'ScreenLayoutApplicationFeatureCode'"
      :displayExpr="'ReportDisplayName'"
      :drop-down-options="{ width: 200 }"
      class="gc-dropdown-icon-button"
      :icon="'message'"
      styling-mode="text"
      :show-arrow-icon="false"
      :onItemClick="onItemClick"
    />
    <!-- v-if="getItems.length > 1" -->
    <!-- <DxButton
      class="invoice-print-btn"
      icon="message"
      @click="onItemClick({ itemData: getItems[0] })"
      v-else
    /> -->

    <GcPopup
      :popup-visible="popupVisible"
      :popup-title="'Warning'"
      :back-button-function="popupBackButtonClick"
      :popupHeight="250"
    >
      <span v-html="errorMsg"></span> <br />

      <p>
        <span>
          Please <a @click="onClickToAddContact">click here</a> to configure
          email settings.
        </span>
      </p>
    </GcPopup>
  </div>
</template>
<script>
import { TransactionListService } from "../_services/api/templates/transactions-list.services";
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    dataField: {
      type: String,
      default: "Code",
    },
    refresh: {
      type: Function,
      default: () => {},
    },
    gridColumns: {
      type: [Object, Array],
      default: () => {},
    },
    baseView: {
      type: Object,
    },
  },
  data() {
    return {
      printReports: undefined,
      validationSummaryVisible: false,
      validationItems: [],
      popupVisible: false,
      errorMsg: undefined,
      errorData: undefined,
    };
  },

  computed: {
    getItems() {
      if (this.data.column.BackgroundEmail)
        if (this.data.column.menuItems)
          if (this.data.column.menuItems.makeDisabled)
            return this.data.column.menuItems.makeDisabled(this.data);
          else return this.data.column.BackgroundEmail;
        else return this.data.column.BackgroundEmail;
      else return [];
    },
  },
  methods: {
    onClickToAddContact() {
      this.popupBackButtonClick();

      let baseUrl = process.env.VUE_APP_BASE_URL;
      let url = "";

      if (this.errorData.ContactType == "Customer") {
        if (baseUrl === "/")
          url = `${baseUrl}customer-contact/${this.errorData.PartnerCode}`;
        else url = `/customer-contact/${this.errorData.PartnerCode}`;
      } else if (this.errorData.ContactType == "Supplier") {
        if (baseUrl === "/")
          url = `${baseUrl}supplier-contact/${this.errorData.PartnerCode}`;
        else url = `/supplier-contact/${this.errorData.PartnerCode}`;
      }

      var route = this.$router.resolve({ path: url });
      window.open(route.href, "_blank");
    },
    popupBackButtonClick() {
      this.popupVisible = false;
    },
    async onItemClick(data) {
      this.showLoading(true);
      if (data.itemData.ScreenName === "Batch Payment List") {
        let referenceField = this.data.column.ReferenceNoField;
        let referenceNo = this.data.data[referenceField];
        TransactionListService.batchPaymentListReportBackgroundEmail({
          ReportName: data.itemData.ReportDisplayName,
          ScreenName: data.itemData.ScreenName,
          TransactionCode: "RunId",
          ReferenceNo: referenceNo,
        })
          .then((res) => {
            this.showLoading(false);

            if (res.data.ReloadRecords) {
              this.$notify(
                `${data.itemData.ReportDisplayName} email notification queued successfully`,
                "success"
              );
              this.refresh();
            } else {
              if (
                res.data.ContactType == "Customer" ||
                res.data.ContactType == "Supplier"
              ) {
                this.popupVisible = true;
                this.errorData = res.data;
                this.errorMsg = res.data.Message;
              }
            }
          })
          .catch((err) => {
            if (err) this.showLoading(false);
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Failed",
            });
          });
      } else {
        var referenceNoField = undefined;
        if (this.data.column.ReferenceNoField)
          referenceNoField = this.data.column.ReferenceNoField;
        else if (this.data.column.ReferenceNoFields) {
          this.data.column.ReferenceNoFields.forEach((element) => {
            if (element.ReportDisplayName == data.itemData.ReportDisplayName) {
              referenceNoField = element.ReferenceNoField;
            }
          });
        }

        // ReferenceNo should be a String
        let referenceNo = "" + this.data.data[referenceNoField];

        TransactionListService.reportBackgroundEmail({
          ReportName: data.itemData.ReportDisplayName,
          ScreenName: data.itemData.ScreenName,
          TransactionCode: data.itemData.TransactionCode,
          ReferenceNo: referenceNo,
        })
          .then((res) => {
            this.showLoading(false);

            if (res.data.ReloadRecords) {
              if (
                data.itemData.ScreenLayoutApplicationFeatureCode ===
                "ReportCofA"
              ) {
                this.$notify(
                  `Certificate of Analysis request submitted successfully.`,
                  "success"
                );
              } else {
                this.$notify(
                  `${data.itemData.ReportDisplayName} email notification queued successfully`,
                  "success"
                );
              }
              this.refresh();
            } else {
              if (
                res.data.ContactType == "Customer" ||
                res.data.ContactType == "Supplier"
              ) {
                this.popupVisible = true;
                this.errorData = res.data;
                this.errorMsg = res.data.Message;
              }
            }
          })
          .catch((err) => {
            if (err) this.showLoading(false);
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Failed",
            });
          });
      }
    },
  },
};
</script>

<style lang="scss"></style>
